import { render, staticRenderFns } from "./InformationDynamics.vue?vue&type=template&id=36074677&scoped=true&"
import script from "./InformationDynamics.vue?vue&type=script&lang=js&"
export * from "./InformationDynamics.vue?vue&type=script&lang=js&"
import style0 from "./InformationDynamics.vue?vue&type=style&index=0&id=36074677&scoped=true&lang=css&"
import style1 from "./InformationDynamics.vue?vue&type=style&index=1&id=36074677&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36074677",
  null
  
)

export default component.exports